




import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL; // e.g., https://payyug.in/api

// 1️⃣ Assign permissions (POST)
export const assignPermissions = createAsyncThunk(
  "permissions/assignPermissions",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/assign-permission`, payload);
      toast.success("Permissions assigned successfully!");
      return response.data;
    } catch (error) {
      toast.error("Failed to assign permissions.");
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// // 2️⃣ Fetch all roles
// export const fetchRoles = createAsyncThunk(
//   "permissions/fetchRoles",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/all-roles`);
//       return response.data.roles || [];
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );



// ✅ GET all roles
export const fetchRoles = createAsyncThunk(
  'roles/fetchRoles',
  async (_, { rejectWithValue }) => {

          const SuperAdminId = localStorage.getItem("adminuserId"); // 🔑 get from localStorage

    try {
      const response = await axios.get(`${API_URL}/all-roles`, 

{
    params: {
          SuperAdminId, // ✅ filter applied
        },
}



      );

      // 🔹 Debug logs
      console.log("📌 Raw API \roels):", response.data);
      console.log("📌 Extracted roles:", response.data.roles);
      return response.data.roles;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch roles');
    }
  }
);

// // 3️⃣ Fetch all branches (with pagination + fetchAll)
// export const fetchBranches = createAsyncThunk(
//   "permissions/fetchBranches",
//   async ({ page = 1, limit = 10, fetchAll = false }, { rejectWithValue }) => {
//     try {
//       const superAdminId = localStorage.getItem("adminuserId");

//       const params = { SuperAdminId: superAdminId };
//       if (fetchAll) {
//         params.limit = "all"; // backend should handle "all"
//       } else {
//         params.page = page;
//         params.limit = limit;
//       }

//       const res = await axios.get(`${API_URL}/get-branch`, { params });
//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data?.message || err.message);
//     }
//   }
// );


export const fetchBranches = createAsyncThunk(
  "permissions/fetchBranches",
  async ({ page = 1, limit = 10, fetchAll = false }, { rejectWithValue }) => {
    try {
      const superAdminId = localStorage.getItem("adminuserId");

      const params = { SuperAdminId: superAdminId };
      if (fetchAll) {
        params.limit = "all";
      } else {
        params.page = page;
        params.limit = limit;
      }

      const res = await axios.get(`${API_URL}/get-branch`, { params });

      

      // ✅ Always return an array
      return res.data.branches || [];
    } catch (err) {
      console.error("❌ fetchBranches error:", err.response?.data || err.message);
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// 4️⃣ Fetch all employees (with filters + pagination + auth)
export const fetchEmployees = createAsyncThunk(
  "permissions/fetchEmployees",
  async (
    { page = 1, limit = 10, userId = "", fetchAll = false, roleName = "", branchName = "" },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      if (!token || token === "undefined") {
        throw new Error("No auth token found");
      }

      const params = new URLSearchParams({ superAdminId });
      if (fetchAll) {
        params.append("fetchAll", true);
      } else {
        params.append("page", page);
        params.append("limit", limit);
      }

      if (userId) params.append("userId", userId);
      if (roleName) params.append("roleName", roleName);
      if (branchName) params.append("branchName", branchName);

      const response = await axios.get(`${API_URL}/get-employ?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return {
        data: response.data.data || [],
        currentPage: response.data.currentPage || 1,
        totalPages: response.data.totalPages || 1,
        totalEmployees: response.data.totalEmployees || 0,
      };
    } catch (error) {
      toast.error("Failed to fetch employees");
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Slice
const permissionSlice = createSlice({
  name: "permissions",
  initialState: {
    loading: false,
    roles: [],
    branches: [],
    employees: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalEmployees: 0,
    },
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Assign permissions
      .addCase(assignPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignPermissions.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(assignPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch roles
      .addCase(fetchRoles.fulfilled, (state, action) => {
  state.roles = Array.isArray(action.payload) ? action.payload : [];

                  console.log("✅ roles stored in state:", action.payload);

      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Fetch branches
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.branches = action.payload;




      })
      .addCase(fetchBranches.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Fetch employees
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.employees = action.payload.data;
        state.pagination = {
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          totalEmployees: action.payload.totalEmployees,
        };
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default permissionSlice.reducer;
